module.exports = __webpack_public_path__ + "img/money-back.3a095f5d.svg";